import React from 'react';
import { Section } from './ui/Section';
export function ContentOverview() {
  const tomos = [{
    title: 'TOMOS 1 & 2',
    subtitle: 'Psicología y Arquitectura Técnica',
    desc: 'Neurociencia del movimiento, perfil del alumno adulto y los 20 errores técnicos más comunes con sus correcciones.',
    icon: '📚'
  }, {
    title: 'TOMOS 3 & 4',
    subtitle: 'Braceo, Estética y Ritmo',
    desc: 'Las 5 posiciones del braceo, técnica de muñeca, compás de 3 y los 5 golpes fundamentales del zapateado.',
    icon: '💃'
  }, {
    title: 'TOMOS 5 & 6',
    subtitle: 'Estilos, Gestión y Liderazgo',
    desc: 'Los 5 estilos principales, gestión de conflictos, liderazgo de grupos y modelo de negocio escalable.',
    icon: '🌸'
  }];
  return <Section data-id="element-53">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-3 text-brand-title" data-id="element-54">
        📦 ¿Qué Incluye el Manual PRO?
      </h2>
      <p className="text-center text-brand-text mb-8 font-body" data-id="element-55">
        Herramientas en PDF listas para usar desde hoy
      </p>

      <div className="max-w-4xl mx-auto space-y-6" data-id="element-56">
        {tomos.map((tomo, i) => <div key={i} className="bg-white border border-brand-border rounded-2xl p-6 shadow-card hover:shadow-card-hover transition-all" data-id="element-57">
            <div className="flex items-start gap-4 mb-3" data-id="element-58">
              <span className="text-4xl" data-id="element-59">{tomo.icon}</span>
              <div data-id="element-60">
                <h3 className="font-heading text-xl font-bold text-brand-title mb-1" data-id="element-61">
                  {tomo.title}
                </h3>
                <p className="font-body text-brand-subtitle font-semibold mb-2" data-id="element-62">
                  {tomo.subtitle}
                </p>
                <p className="font-body text-brand-text text-sm leading-relaxed" data-id="element-63">
                  {tomo.desc}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
}